@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)) {
    <app-multiobjective-responses-explain [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-multiobjective-responses-explain>
  }
  @if (getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)) {
    <app-multicriteria-responses-explain [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-multicriteria-responses-explain>
  }
  @if (getAnalysisService().isConsensusByType(decision_table?.framework.analysis_type)) {
    <app-consensus-responses-explain [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-consensus-responses-explain>
  }
}
